import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CockpitComponent } from './components/cockpit/cockpit.component';
import { RouterModule, Routes } from '@angular/router';
import { RouteNames } from '../../route.name';
import { InsightSharedModule } from '../insight-shared/insight-shared.module';

const routes: Routes = [
    {path: RouteNames.BASE, component: CockpitComponent}
];

@NgModule({
    declarations: [
        CockpitComponent
    ],
    imports: [
        CommonModule,
        InsightSharedModule,
        RouterModule.forChild(routes)
    ]
})
export class CockpitModule {
}
